import React from 'react';
import { useLang } from '../LanguageContext';
import './HomeFeatures.css';

const ICONS = [
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>,
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="m12 3 2.7 5.8 6.3.8-4.6 4.4 1.2 6.2-5.6-3.1-5.6 3.1 1.2-6.2L3 9.6l6.3-.8z"/></svg>,
  <svg fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M12 3c3 2 6 3 8 3 0 10-4 13-8 15-4-2-8-5-8-15 2 0 5-1 8-3z"/><path d="m9 12 2 2 4-4"/></svg>,
];

const CARDS = [
  {
    h: { ko: '스마트 기저귀 실시간 모니터링', en: 'Real-Time Smart Diaper Monitoring' },
    p: { ko: '스마트 기저귀에 부착된 IoT 센서가 24시간 배뇨·배변 상태를 감지하고, 간병인에게 즉시 알림을 전달합니다',
         en: '24/7 IoT sensors on smart diapers detect urination and bowel movements, instantly alerting caregivers.' },
  },
  {
    h: { ko: '헬스케어 데이터 분석', en: 'Healthcare Data Analytics' },
    p: { ko: '스마트 기저귀 센서에서 수집된 데이터를 분석하여 개인별 맞춤 케어 패턴을 제공합니다',
         en: 'Sensor data is analyzed to build a personalized care pattern for each resident.' },
  },
  {
    h: { ko: '욕창 예방 및 건강 보호', en: 'Pressure Ulcer Prevention' },
    p: { ko: '기저귀 교체 시점을 정확히 알려 욕창·피부염을 예방하고 어르신의 건강을 보호합니다',
         en: 'Precise change timing helps prevent pressure ulcers and dermatitis.' },
  },
];

function HomeFeatures() {
  const { lang } = useLang();
  return (
    <section className="hf" aria-label={lang === 'en' ? 'Key features' : '핵심 기능'}>
      <div className="hf-grid">
        {CARDS.map((c, i) => (
          <div className="hf-card" key={i}>
            <div className="hf-ring">{ICONS[i]}</div>
            <h3>{c.h[lang]}</h3>
            <p>{c.p[lang]}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeFeatures;
